module.exports = "/0/1-gioi-thieu-ve-ngon-ngu-lap-trinh/index.html.9809f133b2b8d62313a69257668cb67b.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/29425.md
 ** module id = 524
 ** module chunks = 0
 **/